import { render, staticRenderFns } from "./carmichaelInfo.vue?vue&type=template&id=54019062"
import script from "./carmichaelInfo.vue?vue&type=script&lang=js"
export * from "./carmichaelInfo.vue?vue&type=script&lang=js"
import style0 from "./carmichaelInfo.vue?vue&type=style&index=0&id=54019062&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports